<ng-select
    [items]="iconOptions"
    [searchable]="true"
    bindValue="icon"
    [searchFn]="searchIconFn"
    placeholder="Choose application icon"
    appendTo="body"
    [(ngModel)]="icon"
    [clearable]="true"
    (change)="onChangeIcon($event)"
>
    <ng-template ng-label-tmp let-item="item">
        <div class="cdp-ico-opt-row">
            <span class="item-name">
                <span class="app-ico {{ item.icon }}">
                    @if (item.name === iconInitialsName) {
                        <span class="item-initials">APP</span>
                    }</span
                >{{ item.name }}
            </span>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div class="cdp-ico-opt-row">
            <span class="item-name">
                <span class="app-ico {{ item.icon }}">
                    @if (item.name === iconInitialsName) {
                        <span class="item-initials">APP</span>
                    }</span
                >{{ item.name }}
            </span>
            <span class="item-desc" [class.show-ico-description]="showDescription">{{ item.description }}</span>
        </div>
    </ng-template>
</ng-select>
